import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

import {
  ReportingApiResponseBody,
  Workspace,
  WorkspaceResponse,
} from '@digital-platform/reporting/domain';
import { WorkspaceService } from '../../workspace/workspace.service';

export const WorkspaceResolver: ResolveFn<
  Observable<Workspace[]>
> = (): Observable<Workspace[]> => {
  const workspaceService = inject(WorkspaceService);

  return workspaceService.getWorkspaces().pipe(
    map(
      (response: ReportingApiResponseBody<WorkspaceResponse>) =>
        response.body.workspaces
    ),
    shareReplay(1),
    take(1)
  );
};
